<template>
  <div class="main-bg">
    <b-row class="custom-row">
      <div class="logo">
      <a href="/">
        <img class="custom-logo" src="../../assets/income.svg" width="120"/>
      </a>
      </div>
      <b-col align-self="center" md="6" sm="12">
        <div class="custom-form float-right">
          <b-form v-on:submit.prevent="login">
            <div class="register-form">
              <h1 class="register-label">Log in</h1>
              <b-alert show variant="warning" v-if="validationError.password.length || validationError.username.length">
                {{ validationError.username }}{{ validationError.password }}
              </b-alert>
              <b-input-group class="reg-input-field">
                <template #prepend>
                  <b-input-group-text class="show-password">
                    <img :src="getSrc('elements/emailIcon.svg')" alt=""/>
                  </b-input-group-text>
                </template>
                <b-form-input class="reg-input"
                              id="input-username"
                              v-model="authData.username"
                              type="email"
                              :state="validationUsernameState"
                              placeholder="your@example.com"
                              ref="usernameSection"
                              required
                ></b-form-input>
              </b-input-group>

              <b-input-group class="reg-input-field mt-3">
                <template #prepend>
                  <b-input-group-text class="show-password">
                    <img :src="getSrc('elements/passwordIcon.svg')" alt=""/>
                  </b-input-group-text>
                </template>
                <b-form-input
                    class="reg-input"
                    pill
                    id="input-password"
                    :type="openPasswordType?'text':'password'"
                    :state="validationPasswordState"
                    v-model="authData.password"
                    placeholder="your password"
                    ref="passwordSection"
                    required
                ></b-form-input>
                <template #append>
                  <b-input-group-text class="show-password">
                    <img
                        :src="openPasswordType?getSrc('elements/showPassword.svg'):getSrc('elements/hidePassword.svg')"
                        alt=""
                        @click="openPasswordType=!openPasswordType"/>
                  </b-input-group-text>
                </template>
              </b-input-group>
              <b-button
                  class="signup-btn"
                  pill
                  block
                  variant="primary"
                  content-cols-sm
                  content-cols-lg="5"
                  @click="login"
                  type="submit"
              >Log in
              </b-button>
              <b-button
                  class="custom-spacing custom-sn-reg"
                  pill
                  block
                  variant="outline-secondary"
                  @click="redirectTo('facebook')"
              >
                <img class="icon" :src="getSrc('media/facebookIcon.svg')" alt=""/>
                <span>Log in with Facebook</span></b-button>
              <b-button
                  class="custom-spacing input-icons custom-sn-reg"
                  pill
                  block
                  variant="outline-secondary"
                  @click="redirectTo('google-oauth2')">
                <img class="icon" :src="getSrc('media/googleIcon.svg')" alt=""/>
                Log in with Google
              </b-button>
              <b-button
                  class="custom-spacing custom-sn-reg"
                  pill
                  block
                  variant="outline-secondary"
                  @click="redirectTo('apple')">
                <img class="icon" :src="getSrc('media/appleIcon.svg')" alt=""/>
                Log in with Apple
              </b-button>
              <span class="already-ha">
              <span>Forgot your password? - </span>
              <router-link to="/reset-password">Reset password</router-link>
              </span>
              <br>
              <span class="already-ha">
              <span>Don`t have an account? - </span>
              <router-link to="/register">Register</router-link>
              </span>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col
          md="6" sm="0"
          class="disable-sm right-col"
      >
        <right-column/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import RightColumn from '../../components/auth/RightColumn'
import imageMixin from '@/mixins/image'
import trackingHelper from '@/helpers/trackingHelper'
import localStorageHelper from '@/helpers/localStorageHelper'

export default {
  components: {RightColumn},
  mixins: [imageMixin],
  data()
  {
    return {
      authData: {
        username: '',
        password: ''
      },
      validationUsernameState: null,
      validationPasswordState: null,
      validationError: {
        username: '',
        password: ''
      },
      openPasswordType: false
    }
  },
  mounted()
  {
    this.trackLoginFailStatus()
  },
  methods: {
    redirectTo(provider)
    {
      localStorage.setItem('loginProvider', provider)
      this.$auth.login({target: this.$route.query.to}, provider)
    },
    login()
    {
      if (this.authData.username.length === 0)
      {
        this.blink(this.$refs.usernameSection)
        return false
      }
      if (this.authData.password.length === 0)
      {
        this.blink(this.$refs.passwordSection)
        return false
      }
      this.danger = false
      event.preventDefault()
      axios.post('auth0-login', this.authData).then((response) =>
      {
        if (response.data.success === true)
        {
          localStorageHelper.set('loginProvider', 'manual')
          localStorageHelper.set('accessToken', response.data.accessToken)
          localStorageHelper.set('userData', JSON.stringify(response.data.userData))

          if (response.data.userData.exp) {
            localStorageHelper.set('removeAT', response.data.userData.exp)
          }

          const redirectingTo = localStorageHelper.get('targetUrl') ?? '/account'
          localStorageHelper.set('login_success', redirectingTo)
          window.location.href = redirectingTo
        }
        else
        {
          this.validationError = response.data.error
          trackingHelper.pushLoginEvent('login_fail', 'manual', response.data.error.username + response.data.error.password)
          this.validationUsernameState = this.validationError.username.length === 0
          this.validationPasswordState = this.validationError.password.length === 0
        }
      })
    },
    blink(el)
    {
      el.focus()
      el.$el.classList.add('blink-error')
      setTimeout(() =>
      {
        el.$el.classList.remove('blink-error')
      }, 500)
    },
    trackLoginFailStatus()
    {
      const loginProvider = localStorageHelper.get('loginProvider')
      const loginFail = localStorageHelper.get('login_fail')
      if (loginFail)
      {
        trackingHelper.pushLoginEvent('login_fail', loginProvider, loginFail)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-logo {
  position: absolute;
  top: 2rem;
  left: 5rem;
}

.disable-sm {
  display: flex;
  justify-content: center;
}

@media (max-width: 575px) {
  .custom-logo {
    position: initial;
    margin-left: 1rem !important;
    margin-top: 1rem !important;
    margin-bottom: 2rem !important;
  }
  .disable-sm {
    display: none;
  }
}

.custom-spacing {
  margin-bottom: 10px !important;
}

.icon {
  position: relative;
  float: left;
  min-width: 26px;
  margin-top: 0;
  text-align: left;
}

.apple-color {
  fill: #6c757d;
}

.login-label {
  font-size: 48px;
  font-family: Open Sans !important;
}

.custom-spacing:hover .icon .apple-color {
  fill: white;
}

.custom-row {
  margin: 0;
}

.custom-form {
  margin-right: 5vw !important;
}

@media only screen and (min-width: 1250px) {
  .custom-form {
    min-width: 520px;
  }
}

.right-col {
  background-color: rgba(7, 29, 45, 1);
  padding: 0;
}

.main-bg {
  background-color: #F5FBFF;
}

.register-form {
  max-width: 620px;

  .register-label {
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 87px;
    letter-spacing: 1px;
  }

  .reg-input-field {
    height: 72px;
    background: #E2F3FE;
    border: none;
    border-radius: 15px;

    .reg-input {
      height: 72px;
      background: none;
      border: none;
      box-shadow: none;
      font-size: 20px;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill, {
      -webkit-box-shadow: none !important;
      background-image: none !important;
      background-color: transparent !important;
      color: #000000 !important;
      -webkit-text-fill-color: #000;
    }
  }

  .blink-error {
    color: red !important;
    border: 1px dotted red !important;
    border-radius: 5px;
  }

  .show-password {
    max-height: 72px;
    background: transparent;
    border: none;
  }

  .signup-btn {
    background: #31A6FB;
    height: 72px;
    border: 15px;
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    letter-spacing: 1px;
    color: #F5FBFF;
    margin-bottom: 15px;
    margin-top: 15px;
  }

  .custom-sn-reg {
    height: 48px;
  }

  .custom-sn-reg:hover {
    color: #fff;
    background-color: #31A6FB;
    border-color: #31A6FB;
  }

  .already-ha {
    margin-top: 15px;
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 1px;
  }
}

@media only screen and (min-width: 576px) and (max-width: 765px) {
  .register-form{
    min-width: 500px;
  }
  .logo {
    height: 110px;
    width: 100%;
  }
}

@media only screen and (min-width: 765px) and (max-height: 800px)  {
  .logo {
    display: none;
  }
}

@media only screen and (min-width: 1765px)  {
  .logo {
    display: block;
  }
}
</style>
